import axios from 'axios';

import { apiFactory } from '@chronos/api-client/chronosApi';
import config from 'app-config';

axios.interceptors.response.use((r) => r.data);
const req = (params) => axios(params);

export const chronosApi = apiFactory({
  makeRequest: req,
  methods: [
    ['auth', '/admin/auth', 'POST'],
    ['me', '/admin/me', 'GET'],
    ['charts', '/admin/charts', 'POST'],
    ['getWorklogStats', '/admin/worklogStats', 'POST'],
    ['getAccountStats', '/admin/accountStats', 'POST'],
    ['getTransactionStats', '/admin/transactionStats', 'POST'],
    ['getPaymentTransactions', '/admin/payments/filter', 'POST'],
    ['saveClient', '/admin/client/', 'POST'],
    ['searchClient', '/admin/client/{clientId}', 'GET'],
  ],
});

chronosApi.init({ baseUrl: config.chronosApiUrl });
